<script>
  import { mapGetters } from 'vuex'

  const uuidv4 = require('uuid/v4')

  export default {
    computed: {
      ...mapGetters([
        'sessionStorageKey',
        'urlStorageKey',
        'userAgentStorageKey',
        'layoutIdStorageKey',

        'attributionIdStorageKey',
        'attributionOrganicStoreDownloadURLsStorageKey',
        'attributionPlatformStorageKey',
        'attributionStoreDownloadURLsStorageKey',

        'appKey',
        'offer',
        'version',

        'env',
      ])
    },
    mounted () {
      this.$nextTick(function () {
        // if (this.$session.exists(this.sessionStorageKey)) {
        //   this.$session.remove(this.sessionStorageKey);
        // }
        // if (this.$session.exists(this.attributionIdStorageKey)) {
        //   this.$session.remove(this.attributionIdStorageKey);
        // }

        // Attrbution handling
        if (!this.$session.exists(this.sessionStorageKey)) {
          let url = window.location.href
          let userAgent = navigator.userAgent
          let layoutId = 'c2ef7156-fff2-4d08-9138-8918593ab0d4'
          let sessionId = uuidv4()

          // SESSION ID
          this.$store.commit('SESSION_ID_SET', sessionId)
          this.$session.set(this.sessionStorageKey, sessionId);
          // URL
          this.$store.commit('URL_SET', url)
          this.$session.set(this.urlStorageKey, url)
          // USER AGENT
          this.$store.commit('USER_AGENT_SET', userAgent)
          this.$session.set(this.userAgentStorageKey, userAgent)
          // LAYOUT ID
          this.$store.commit('LAYOUT_ID_SET', layoutId)
          this.$session.set(this.layoutIdStorageKey, layoutId)

          // campaign=LEARNING-iOS-US&campaign_id=23843613936590437&adset=LEARNING-iOS-US&adset_id=23843613936610437&ad=BMP_1e6fd48a-e7ce-4fc1-ba1d-7ad62f8f405e-Beat Maker Pro&ad_id=23843613995480437&source=facebook&channel=traffic&target_platform=ios&target_key=learning_sampler&ad_type=video
          // let androidUA = 'Mozilla/5.0 (Linux; Android 7.0; SAMSUNG SM-J710MN) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/10.1 Chrome/71.0.3578.99 Mobile Safari/537.36'
          // let iosUA = 'Mozilla/5.0 (iPhone; CPU iPhone OS 13_1_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/15E148 [FBAN/FBIOS;FBDV/iPhone12,1;FBMD/iPhone;FBSN/iOS;FBSV/13.1.3;FBSS/2;FBID/phone;FBLC/en_US;FBOP/5;FBCR/AT&T]'
          // userAgent = iosUA

          this.$store.dispatch('ATTRIBUTION', {
            env: this.env,
            headers: { appKey: this.appKey, offer: this.offer, version: this.version },
            body: {
              session_id: sessionId,
              url: url,
              user_agent: userAgent,
              layout_id  : layoutId,
            }
          })
          .then((response) => {
            this.$session.set(this.attributionIdStorageKey, response.attribution_id);
            this.$session.set(this.attributionOrganicStoreDownloadURLsStorageKey, response.organic_store_download_urls);
            this.$session.set(this.attributionPlatformStorageKey, response.platform);
            this.$session.set(this.attributionStoreDownloadURLsStorageKey, response.store_download_urls);
          })
          .catch((error) => console.log(error))
        } else {
          // SESSION ID
          let oldSessionId = this.$session.get(this.sessionStorageKey)
          this.$store.commit('SESSION_ID_SET', oldSessionId)
          // URL
          let oldurl = this.$session.get(this.urlStorageKey)
          this.$store.commit('URL_SET', oldurl)
          // USER AGENT
          let olduserAgent = this.$session.get(this.userAgentStorageKey)
          this.$store.commit('USER_AGENT_SET', olduserAgent)
          // LAYOUT ID
          let oldlayoutId = this.$session.get(this.layoutIdStorageKey)
          this.$store.commit('LAYOUT_ID_SET', oldlayoutId)

          // ATTRIBUTION
          this.$store.commit('ATTRIBUTION_STATUS_SET', 'done')

          let attributionId = this.$session.get(this.attributionIdStorageKey);
          this.$store.commit('ATTRIBUTION_ID_SET', attributionId)
          let attributionPlatform = this.$session.get(this.attributionPlatformStorageKey);
          this.$store.commit('ATTRIBUTION_PLATFORM_SET', attributionPlatform)
          let attributionStoreDownloadURLs = this.$session.get(this.attributionStoreDownloadURLsStorageKey);
          let attributionOrganicStoreDownloadURLs = this.$session.get(this.attributionOrganicStoreDownloadURLsStorageKey);
          this.$store.commit('ATTRIBUTION_URLS_SET', { storeUrls: attributionStoreDownloadURLs, organicStoreUrls: attributionOrganicStoreDownloadURLs })
        }
      })
    }
  }
</script>
